import type { IconProps } from "./icon-types";

/**
 * 일시정지(pause). DataReview 재생 컨트롤 등에서 사용.
 *
 * 글리프는 `react-icons/lu`의 `LuPause`(Lucide `pause`) 기반 — 모서리를 살짝 더 둥글게(rx 1.5) 조정.
 * 미디어 컨트롤 관례에 맞춰 채움(fill) 처리. c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 */
export const PauseIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <rect x="14" y="4" width="4" height="16" rx="1.5" />
    <rect x="6" y="4" width="4" height="16" rx="1.5" />
  </svg>
);
